var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"categories",attrs:{"headers":_vm.headers,"loading-text":"Загрузка категорий","api-url":"/api/feedbacks","modelName":"categories","showSelect":false,"redirectToEditPageOnRowClick":true}})}
var staticRenderFns = []

export { render, staticRenderFns }